import { Table } from "react-bootstrap";
import SpinnerBlock from "components/others/SpinnerBlock";
import { useObject } from "../context/ObjectProvider";
import TableHeadTdOrder from "components/others/TableHeadTdOrder";
import { useTranslation } from "react-i18next";
import ObjectsTableBody from "./ObjectsTableBody";

const ObjectsTable = ({objectsList, fetchObjects, setClientInfoId, setTasksObjectId}) => {

    const { t } = useTranslation(['Objects']);
    const { showSpinner, setShowSpinner,
            objectsOrder, setObjectsOrder,
            objectsDesc, setObjectsDesc,
            showDebtor, showClient, onlySale } = useObject();

    const handleOrderClick = (value, desc) => {
        setObjectsOrder(value); 
        setObjectsDesc(desc);
    }

    const tableMods = [
        onlySale ? 'ObjectTable--sales' : '',
        showDebtor ? 'ObjectTable--payments' : '',
        showClient ? 'ObjectTable--client' : '',
    ].filter(Boolean).join(' ');

    return (<>
        <SpinnerBlock 
            onlyBlur={true}
            show={showSpinner}/> 

        <div className="crm-table-wrap objects-table-wrap">
            <Table className={`ObjectTable table-hover${tableMods ? ` ${tableMods}` : ''}`}>
                <thead>
                    <tr className="bg-light">
                        <td className="head-status"></td>

                        <td className="head-name">
                            <TableHeadTdOrder
                                title={t('fields.name')}
                                onClick={handleOrderClick}
                                value={objectsOrder}
                                desc={objectsDesc}
                                fieldName={onlySale ? 'object_name' : 'client_name'}/>
                        </td>

                        {showClient ? (
                            <td className="head-client">
                                <TableHeadTdOrder
                                    title={t('fields.client')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='client_name'/>
                            </td>
                        ) : null}

                        {!onlySale ? (
                            <td className="head-team">
                                <TableHeadTdOrder
                                    title={t('fields.team')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='team_name'/>     
                            </td>
                        ) : null}

                        {onlySale ? (
                            <td className="head-created">
                                <TableHeadTdOrder
                                    className="cursor-pointer d-flex align-items-center"
                                    title={t('fields.saleDate')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='object_created'/>    
                            </td>
                        ) : null}

                        {onlySale ? (
                            <td className="head-author">
                                <TableHeadTdOrder
                                    title={t('fields.author')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='user_name'/>    
                            </td>
                        ) : null}

                        <td className="head-price text-end">
                            <TableHeadTdOrder
                                className="cursor-pointer d-flex align-items-center justify-content-end"
                                title={t('fields.price')}
                                onClick={handleOrderClick} 
                                value={objectsOrder}
                                desc={objectsDesc}
                                fieldName='object_price'/>    
                        </td>
                        {showDebtor ? (
                            <>
                                <td className="head-payments text-end">{t('fields.payments')}</td>
                                <td className="head-pay-status text-center">{t('fields.payStatus')}</td>
                            </>
                        ) : null}
                        {!onlySale ? (
                            <td className="head-created">
                                <TableHeadTdOrder
                                    className="cursor-pointer d-flex align-items-center justify-content-end"
                                    title={t('fields.date')}
                                    onClick={handleOrderClick}
                                    value={objectsOrder}
                                    desc={objectsDesc}
                                    fieldName='client_created'/>    
                            </td>
                        ) : null}
                        <td className="head-action">{t('fields.action')}</td>
                    </tr>
                </thead> 
                
                <ObjectsTableBody
                    setClientInfoId={setClientInfoId}
                    setTasksObjectId={setTasksObjectId}
                    objectsList={objectsList}
                    fetchObjects={fetchObjects}/>
            </Table>
        </div>
    </>)
}

export default ObjectsTable; 
